// material-ui
import { Typography, Stack } from '@mui/material';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import { useState } from 'react';
import Terms from './PrivacyPolicy/Terms';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => {
  const date = new Date().getFullYear();
  const stylefooter = {
    fontSize: '12px',
    color: '#7F7F7F',
    fontWeight: '400',
    stylehoverfooter: {
      fontSize: '13px',
      color: '#7F7F7F',
      fontWeight: '400',
      cursor: 'pointer',
      '&:hover': { color: '#282828' }
    }
  };

  const [open, setOpen] = useState(false);
  const[TermsOpen,setTermsOpen]= useState(false);

  const handleModelOpen=()=>{
    setOpen(true);
  }
  const handleTermsModelOpen=()=>{
    setTermsOpen(true);
  }
  const handleTermsModelBack=()=>{
    setTermsOpen(false);
  }
  const handleClose=()=>{
    setOpen(false)
  }


  return (
    <>
      <PrivacyPolicy open={open} handleClose={handleClose}/>
      <Terms open={TermsOpen} handleClose={handleTermsModelBack}/>
      <Stack direction="column" spacing={2}>
        <Typography
          variant="subtitle2"
          sx={stylefooter}
          //  component={Link} href="https://berrydashboard.io"  target="_blank" underline="hover"
        >
          Copyright © {date} FIA Global. All rights reserved.{' '}
        </Typography>
        <Stack direction="row" spacing={3}>
          <Typography
            variant="subtitle2"
            sx={stylefooter.stylehoverfooter}
            //  component={Link} href="https://codedthemes.com" target="_blank" underline="hover"
            onClick={()=>handleTermsModelOpen()}
          >
            Terms & Conditions
          </Typography>
          <Typography
            variant="subtitle2"
            sx={stylefooter.stylehoverfooter}
            //  component={Link} href="https://codedthemes.com" target="_blank" underline="hover"
            onClick={()=>handleModelOpen()}
          >
            Privacy Policy
          </Typography>
          <Typography
            variant="subtitle2"
            sx={stylefooter.stylehoverfooter}
            //  component={Link} href="https://codedthemes.com" target="_blank" underline="hover"
          >
            Cookie Policy
          </Typography>
          <Typography
            variant="subtitle2"
            sx={stylefooter.stylehoverfooter}
            //  component={Link} href="https://codedthemes.com" target="_blank" underline="hover"
          >
            Disclaimer
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};
export default AuthFooter;
